// import React, { useState } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   IconButton,
//   Box,
//   Typography,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Button,
//   CircularProgress,
//   Snackbar,
//   Alert,
// } from "@mui/material";
// import { Close, Group, Download } from "@mui/icons-material";
// import axios from "axios";
// import { BASE_URL } from "../../../../services/configUrls";

// const ViewCoordinatorsModal = ({
//   open,
//   onClose,
//   coordinators = [],
//   bookslotId,
// }) => {
//   const [downloading, setDownloading] = useState({});
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });

//   console.log(bookslotId);

//   const handleDownloadCertificate = async (coordinatorId, coordinatorName) => {
//     setDownloading((prev) => ({ ...prev, [coordinatorId]: true }));

//     try {
//       const response = await axios.post(
//         `${BASE_URL}/event/fdp-coordinator-certificate`,
//         {
//           bookslot_id: bookslotId,
//           coordinator_id: coordinatorId,
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//           },
//         }
//       );

//       const { certificate_base64 } = response.data;

//       // Convert base64 to blob and download
//       const byteCharacters = atob(certificate_base64);
//       const byteNumbers = new Array(byteCharacters.length);
//       for (let i = 0; i < byteCharacters.length; i++) {
//         byteNumbers[i] = byteCharacters.charCodeAt(i);
//       }
//       const byteArray = new Uint8Array(byteNumbers);
//       const blob = new Blob([byteArray], { type: "application/pdf" });

//       // Create download link
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = url;
//       link.download = `${coordinatorName.replace(/\s+/g, "_")}_Certificate.pdf`;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(url);

//       setSnackbar({
//         open: true,
//         message: "Certificate downloaded successfully!",
//         severity: "success",
//       });
//     } catch (error) {
//       console.error("Error downloading certificate:", error);
//       setSnackbar({
//         open: true,
//         message:
//           error.response?.data?.detail || "Failed to download certificate",
//         severity: "error",
//       });
//     } finally {
//       setDownloading((prev) => ({ ...prev, [coordinatorId]: false }));
//     }
//   };

//   const handleCloseSnackbar = () => {
//     setSnackbar({ ...snackbar, open: false });
//   };

//   return (
//     <>
//       <Dialog
//         open={open}
//         onClose={onClose}
//         maxWidth="md"
//         fullWidth
//         PaperProps={{
//           sx: {
//             borderRadius: 3,
//             boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
//           },
//         }}
//       >
//         <DialogTitle
//           sx={{
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             pb: 2,
//             borderBottom: "1px solid #e0e0e0",
//           }}
//         >
//           <Box display="flex" alignItems="center" gap={1}>
//             <Group sx={{ color: "#1976d2" }} />
//             <Typography variant="h6" fontWeight={600}>
//               Program Coordinators
//             </Typography>
//           </Box>
//           <IconButton onClick={onClose} size="small">
//             <Close />
//           </IconButton>
//         </DialogTitle>

//         <DialogContent sx={{ mt: 2, p: 0 }}>
//           {coordinators && coordinators.length > 0 ? (
//             <TableContainer
//               component={Paper}
//               elevation={0}
//               sx={{
//                 border: "none",
//               }}
//             >
//               <Table>
//                 <TableHead>
//                   <TableRow sx={{ backgroundColor: "#f8fafc" }}>
//                     <TableCell sx={{ fontWeight: 600, fontSize: "0.875rem" }}>
//                       S.No
//                     </TableCell>
//                     <TableCell sx={{ fontWeight: 600, fontSize: "0.875rem" }}>
//                       Name
//                     </TableCell>
//                     <TableCell sx={{ fontWeight: 600, fontSize: "0.875rem" }}>
//                       Email
//                     </TableCell>
//                     <TableCell sx={{ fontWeight: 600, fontSize: "0.875rem" }}>
//                       Mobile
//                     </TableCell>
//                     <TableCell sx={{ fontWeight: 600, fontSize: "0.875rem" }}>
//                       Action
//                     </TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {coordinators.map((coordinator, index) => (
//                     <TableRow
//                       key={coordinator.id || index}
//                       sx={{
//                         "&:hover": {
//                           backgroundColor: "#f8fafc",
//                         },
//                       }}
//                     >
//                       <TableCell>{index + 1}</TableCell>
//                       <TableCell>
//                         <Typography variant="body2" fontWeight={500}>
//                           {coordinator.name}
//                         </Typography>
//                       </TableCell>
//                       <TableCell>
//                         <Typography variant="body2">
//                           {coordinator.email}
//                         </Typography>
//                       </TableCell>
//                       <TableCell>
//                         <Typography variant="body2">
//                           {coordinator.mobile}
//                         </Typography>
//                       </TableCell>
//                       <TableCell>
//                         <Button
//                           variant="contained"
//                           size="small"
//                           startIcon={
//                             downloading[coordinator.id] ? (
//                               <CircularProgress size={16} color="inherit" />
//                             ) : (
//                               <Download />
//                             )
//                           }
//                           onClick={() =>
//                             handleDownloadCertificate(
//                               coordinator.id,
//                               coordinator.name
//                             )
//                           }
//                           disabled={downloading[coordinator.id]}
//                           sx={{
//                             textTransform: "none",
//                             backgroundColor: "#1976d2",
//                             "&:hover": {
//                               backgroundColor: "#1565c0",
//                             },
//                           }}
//                         >
//                           {downloading[coordinator.id]
//                             ? "Downloading..."
//                             : "Certificate"}
//                         </Button>
//                       </TableCell>
//                     </TableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//           ) : (
//             <Box
//               display="flex"
//               justifyContent="center"
//               alignItems="center"
//               py={4}
//             >
//               <Typography color="text.secondary">
//                 No coordinators assigned
//               </Typography>
//             </Box>
//           )}
//         </DialogContent>
//       </Dialog>

//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={4000}
//         onClose={handleCloseSnackbar}
        
//         anchorOrigin={{ vertical: "top", horizontal: "center" }}
//       >
//         <Alert
//           onClose={handleCloseSnackbar}
//           severity={snackbar.severity}
//           variant="filled"
//           sx={{ width: "100%" }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </>
//   );
// };

// export default ViewCoordinatorsModal;

import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import { Close, Group, Download } from "@mui/icons-material";
import axios from "axios";
import { BASE_URL } from "../../../../services/configUrls";

const ViewCoordinatorsModal = ({
  open,
  onClose,
  coordinators = [],
  bookslotId,
}) => {
  const [downloading, setDownloading] = useState({});
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  console.log(bookslotId);

  const handleDownloadCertificate = async (coordinatorId, coordinatorName) => {
    setDownloading((prev) => ({ ...prev, [coordinatorId]: true }));

    try {
      const response = await axios.post(
        `${BASE_URL}/event/fdp-coordinator-certificate`,
        {
          bookslot_id: bookslotId,
          coordinator_id: coordinatorId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );

      const { certificate_base64 } = response.data;

      // Convert base64 to blob and download
      const byteCharacters = atob(certificate_base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });

      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${coordinatorName.replace(/\s+/g, "_")}_Certificate.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      setSnackbar({
        open: true,
        message: "Certificate downloaded successfully!",
        severity: "success",
      });
    } catch (error) {
      console.error("Error downloading certificate:", error);
      setSnackbar({
        open: true,
        message:
          error.response?.data?.detail || "Failed to download certificate",
        severity: "error",
      });
    } finally {
      setDownloading((prev) => ({ ...prev, [coordinatorId]: false }));
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pb: 2,
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <Box display="flex" alignItems="center" gap={1}>
            <Group sx={{ color: "#1976d2" }} />
            <Typography variant="h6" fontWeight={600}>
              Program Coordinators
            </Typography>
          </Box>
          <IconButton onClick={onClose} size="small">
            <Close />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ mt: 2, p: 0 }}>
          {coordinators && coordinators.length > 0 ? (
            <TableContainer
              component={Paper}
              elevation={0}
              sx={{
                border: "none",
              }}
            >
              <Table>
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#f8fafc" }}>
                    <TableCell sx={{ fontWeight: 600, fontSize: "0.875rem" }}>
                      S.No
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, fontSize: "0.875rem" }}>
                      Name
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, fontSize: "0.875rem" }}>
                      Email
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, fontSize: "0.875rem" }}>
                      Mobile
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, fontSize: "0.875rem" }}>
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {coordinators.map((coordinator, index) => (
                    <TableRow
                      key={coordinator.id || index}
                      sx={{
                        "&:hover": {
                          backgroundColor: "#f8fafc",
                        },
                      }}
                    >
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>
                        <Typography variant="body2" fontWeight={500}>
                          {coordinator.name}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {coordinator.email}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {coordinator.mobile}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Button
                          variant="contained"
                          size="small"
                          startIcon={
                            downloading[coordinator.id] ? (
                              <CircularProgress size={16} color="inherit" />
                            ) : (
                              <Download />
                            )
                          }
                          onClick={() =>
                            handleDownloadCertificate(
                              coordinator.id,
                              coordinator.name
                            )
                          }
                          disabled={downloading[coordinator.id]}
                          sx={{
                            textTransform: "none",
                            backgroundColor: "#1976d2",
                            "&:hover": {
                              backgroundColor: "#1565c0",
                            },
                          }}
                        >
                          {downloading[coordinator.id]
                            ? "Downloading..."
                            : "Certificate"}
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              py={4}
            >
              <Typography color="text.secondary">
                No coordinators assigned
              </Typography>
            </Box>
          )}
        </DialogContent>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ViewCoordinatorsModal;
